// /app/frontend/src/components/frugal-v2/components/scheduled/ScheduledChargeItem.jsx
// Single scheduled charge item (60 lines)

import React from 'react';
import { Edit2, Trash2, Calendar, RefreshCw } from 'lucide-react';

export default function ScheduledChargeItem({ charge, onEdit, onDelete, t }) {
  const isAnnual = !charge.year;
  
  return (
    <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-colors">
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <span className="text-white font-medium">{charge.name}</span>
          {isAnnual ? (
            <span className="flex items-center gap-1 text-xs text-amber-400 bg-amber-500/20 px-2 py-0.5 rounded">
              <RefreshCw className="w-3 h-3" /> {t.annual}
            </span>
          ) : (
            <span className="flex items-center gap-1 text-xs text-sky-400 bg-sky-500/20 px-2 py-0.5 rounded">
              <Calendar className="w-3 h-3" /> {t.oneTime}
            </span>
          )}
        </div>
        <div className="flex items-center gap-3 mt-1 text-sm text-slate-400">
          <span>{charge.category}</span>
          <span>•</span>
          <span>{t.months[charge.month - 1]} {charge.day}</span>
          {charge.year && <span>• {charge.year}</span>}
        </div>
      </div>
      
      <div className="flex items-center gap-3">
        <span className="text-emerald-400 font-semibold">${charge.amount?.toFixed(2)}</span>
        <div className="flex gap-1">
          <button
            onClick={() => onEdit(charge)}
            className="p-1.5 hover:bg-white/10 rounded"
          >
            <Edit2 className="w-4 h-4 text-slate-400" />
          </button>
          <button
            onClick={() => onDelete(charge.id)}
            className="p-1.5 hover:bg-red-500/20 rounded"
          >
            <Trash2 className="w-4 h-4 text-red-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
